import { useEffect } from 'react';

import { cardsActions, useStore } from '@modules';
import { VerificationStatusesEnum } from '@modules/user/types';

const useSubstitutedHolderName = (): string | false => {
  const [{ user }, dispatch] = useStore();
  const { data } = user;
  const kycIsComplete = data?.checks.document === VerificationStatusesEnum.complete;

  const firstName = data?.first_name_en || data?.first_name;
  const lastName = data?.last_name_en || data?.last_name;
  const result = !!firstName && !!lastName && `${firstName} ${lastName}`;
  const substitutedHolderName = kycIsComplete && data?.country_code === 'ng' && result;

  useEffect(() => {
    if (substitutedHolderName) {
      dispatch(cardsActions.setCard({ name: 'holderName', value: substitutedHolderName }));
    }
  }, [substitutedHolderName]);

  return substitutedHolderName;
};

export default useSubstitutedHolderName;
